import { createFileRoute } from "@tanstack/react-router";
import { SupplierContactsTab } from "../../../../pages/suppliers-page/supplier-contacts-tab";

export const Route = createFileRoute("/_auth/_frame/suppliers/$supplierId/contacts")({
  component: SupplierContactsTab,
});
